import { Component } from '@angular/core';
import { Action } from '../../models/core/action';
import { MenuComponent } from '../core/panels/menu.component';
@Component({
  selector: 'app-menu-design',
  imports: [MenuComponent],
  template: `
    <button (click)="myMenu.toggle($event)">app menu</button>
    <app-menu [items]="actions" #myMenu (click)="logAction($event)">
      <ng-template #header><b>header</b></ng-template>
      <ng-template #footer><b>footer</b></ng-template>
    </app-menu>
  `,
  styles: ``,
})
export class MenuDesignComponent {
  actions: Action[] = [
    { label: 'Watchlist', icon: 'fa-star fa-light', routerLink: '/watchlist' },
    { label: 'Preferences', icon: 'fa-gear fa-light' },
    { label: 'Log out', icon: 'fa-sign-out' },
  ];

  protected logAction(action: Action) {
    // action goes here
  }
}
